import { createSlice } from '@reduxjs/toolkit'
import { TAppManagement } from './types'

export const initialState: TAppManagement.TState = {
    currentLocationId: "",
    dashboardChartExpanded: false,
    dashboardShipmentInfoExpaned: false,
    // System-wide display mode. Fetched from backend (appsettings EagleDisplayMode) on bootstrap.
    // Defaults to '3D' (current behavior) until the fetch completes.
    displayMode: (localStorage.getItem('eagleDisplayMode') as TAppManagement.TDisplayMode) || '3D',
    // #8427/SKY-28: a cached value means the mode is already trustworthy on this device,
    // so returning users get a correct redirect immediately; first-time users wait for GetAppConfig.
    displayModeLoaded: !!localStorage.getItem('eagleDisplayMode')
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setCurrentLocationId(state, action) {
            state.currentLocationId = action.payload;
        },
        setDashboardChartExpaned(state, action) {
            state.dashboardChartExpanded = action.payload;
        },
        setDashboardShipmentInfoExpaned(state, action) {
            state.dashboardShipmentInfoExpaned = action.payload;
        },
        setDisplayMode(state, action) {
            state.displayMode = action.payload === '2D' ? '2D' : '3D';
            state.displayModeLoaded = true;
            localStorage.setItem('eagleDisplayMode', state.displayMode);
        }
    },
    extraReducers: builder => {

    }
})

 export const {
     setCurrentLocationId,
     setDashboardChartExpaned,
     setDashboardShipmentInfoExpaned,
     setDisplayMode
 } = appSlice.actions

export default appSlice.reducer
